import {
  createReducer,
  failMapper,
  INITIAL_STATE,
  resetMapper,
  startMapper,
  successMapper,
  Type,
} from 'store/utils';
import { SEARCH_POLICY_ACTIONS } from './constants';

export const initialState = {
  policy: INITIAL_STATE,
};

const searchPolicyMapper: Type[] = [
  {
    type: SEARCH_POLICY_ACTIONS.START,
    mapper: startMapper('policy'),
  },
  {
    type: SEARCH_POLICY_ACTIONS.FAIL,
    mapper: failMapper('policy'),
  },
  {
    type: SEARCH_POLICY_ACTIONS.SUCCESS,
    mapper: successMapper('policy'),
  },
  {
    type: SEARCH_POLICY_ACTIONS.RESET,
    mapper: resetMapper('policy'),
  },
];

export default createReducer({ types: searchPolicyMapper, initialState });
